export default __webpack_public_path__ + "static/media/5k.8c278b9e.gif";